// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/notebook/v1/runtime.proto (package chalk.notebook.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ScalarValue } from "../../arrow/v1/arrow_pb";
import { file_chalk_arrow_v1_arrow } from "../../arrow/v1/arrow_pb";
import type { ColumnProfile } from "../../common/v1/column_profile_pb";
import { file_chalk_common_v1_column_profile } from "../../common/v1/column_profile_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/notebook/v1/runtime.proto.
 */
export const file_chalk_notebook_v1_runtime: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_arrow_v1_arrow, file_chalk_common_v1_column_profile, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputDataframeColumn
 */
export type NotebookOutputDataframeColumn = Message<"chalk.notebook.v1.NotebookOutputDataframeColumn"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputDataframeColumn.
 * Use `create(NotebookOutputDataframeColumnSchema)` to create a new message.
 */
export const NotebookOutputDataframeColumnSchema: GenMessage<NotebookOutputDataframeColumn> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 0);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputDataframePreview
 */
export type NotebookOutputDataframePreview = Message<"chalk.notebook.v1.NotebookOutputDataframePreview"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookOutputDataframeColumn columns = 2;
   */
  columns: NotebookOutputDataframeColumn[];

  /**
   * @generated from field: int64 requested_rows = 4;
   */
  requestedRows: bigint;

  /**
   * @generated from field: int64 returned_rows = 5;
   */
  returnedRows: bigint;

  /**
   * @generated from field: int64 total_rows = 6;
   */
  totalRows: bigint;

  /**
   * @generated from field: bool truncated = 7;
   */
  truncated: boolean;

  /**
   * Preview rows as an Arrow IPC stream (chalk convention: tabular payloads
   * travel as Arrow/parquet bytes, not repeated Structs).
   *
   * @generated from field: bytes arrow_ipc = 8;
   */
  arrowIpc: Uint8Array;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputDataframePreview.
 * Use `create(NotebookOutputDataframePreviewSchema)` to create a new message.
 */
export const NotebookOutputDataframePreviewSchema: GenMessage<NotebookOutputDataframePreview> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 1);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputInlineDataframe
 */
export type NotebookOutputInlineDataframe = Message<"chalk.notebook.v1.NotebookOutputInlineDataframe"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookOutputDataframeColumn columns = 1;
   */
  columns: NotebookOutputDataframeColumn[];

  /**
   * @generated from field: int64 row_count = 3;
   */
  rowCount: bigint;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * Full inline rows as an Arrow IPC stream.
   *
   * @generated from field: bytes arrow_ipc = 5;
   */
  arrowIpc: Uint8Array;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputInlineDataframe.
 * Use `create(NotebookOutputInlineDataframeSchema)` to create a new message.
 */
export const NotebookOutputInlineDataframeSchema: GenMessage<NotebookOutputInlineDataframe> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 2);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputDatasetRevisionRef
 */
export type NotebookOutputDatasetRevisionRef = Message<"chalk.notebook.v1.NotebookOutputDatasetRevisionRef"> & {
  /**
   * @generated from field: string dataset_id = 1;
   */
  datasetId: string;

  /**
   * @generated from field: string dataset_name = 2;
   */
  datasetName: string;

  /**
   * @generated from field: string revision_id = 3;
   */
  revisionId: string;

  /**
   * @generated from field: string branch = 4;
   */
  branch: string;

  /**
   * @generated from field: int64 row_count = 5;
   */
  rowCount: bigint;

  /**
   * @generated from field: string status = 6;
   */
  status: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputDatasetRevisionRef.
 * Use `create(NotebookOutputDatasetRevisionRefSchema)` to create a new message.
 */
export const NotebookOutputDatasetRevisionRefSchema: GenMessage<NotebookOutputDatasetRevisionRef> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 3);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputDatasetRef
 */
export type NotebookOutputDatasetRef = Message<"chalk.notebook.v1.NotebookOutputDatasetRef"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookOutputDatasetRevisionRef revisions = 1;
   */
  revisions: NotebookOutputDatasetRevisionRef[];
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputDatasetRef.
 * Use `create(NotebookOutputDatasetRefSchema)` to create a new message.
 */
export const NotebookOutputDatasetRefSchema: GenMessage<NotebookOutputDatasetRef> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 4);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputSqlResultRef
 */
export type NotebookOutputSqlResultRef = Message<"chalk.notebook.v1.NotebookOutputSqlResultRef"> & {
  /**
   * @generated from field: string operation_id = 1;
   */
  operationId: string;

  /**
   * @generated from field: string query_id = 2;
   */
  queryId: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputSqlResultRef.
 * Use `create(NotebookOutputSqlResultRefSchema)` to create a new message.
 */
export const NotebookOutputSqlResultRefSchema: GenMessage<NotebookOutputSqlResultRef> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 5);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputPythonObjectRef
 */
export type NotebookOutputPythonObjectRef = Message<"chalk.notebook.v1.NotebookOutputPythonObjectRef"> & {
  /**
   * @generated from field: string object_id = 1;
   */
  objectId: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputPythonObjectRef.
 * Use `create(NotebookOutputPythonObjectRefSchema)` to create a new message.
 */
export const NotebookOutputPythonObjectRefSchema: GenMessage<NotebookOutputPythonObjectRef> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 6);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputBlobRef
 */
export type NotebookOutputBlobRef = Message<"chalk.notebook.v1.NotebookOutputBlobRef"> & {
  /**
   * @generated from field: string blob_id = 1;
   */
  blobId: string;

  /**
   * @generated from field: string format = 2;
   */
  format: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: int64 byte_size = 4;
   */
  byteSize: bigint;

  /**
   * @generated from field: string content_sha256 = 5;
   */
  contentSha256: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputBlobRef.
 * Use `create(NotebookOutputBlobRefSchema)` to create a new message.
 */
export const NotebookOutputBlobRefSchema: GenMessage<NotebookOutputBlobRef> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 7);

/**
 * Provenance for a SQL result served from cache. Presence on a dataframe
 * output signals a cache hit; there is deliberately no from_cache boolean.
 *
 * @generated from message chalk.notebook.v1.NotebookSqlCacheInfo
 */
export type NotebookSqlCacheInfo = Message<"chalk.notebook.v1.NotebookSqlCacheInfo"> & {
  /**
   * When the warehouse actually executed the query (the freshness clock shown
   * as the result-age indicator).
   *
   * @generated from field: google.protobuf.Timestamp warehouse_executed_at = 1;
   */
  warehouseExecutedAt?: Timestamp;

  /**
   * The prior cell run whose persisted result blob was copied into this run.
   *
   * @generated from field: string source_cell_run_id = 2;
   */
  sourceCellRunId: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookSqlCacheInfo.
 * Use `create(NotebookSqlCacheInfoSchema)` to create a new message.
 */
export const NotebookSqlCacheInfoSchema: GenMessage<NotebookSqlCacheInfo> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 8);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputDataframe
 */
export type NotebookOutputDataframe = Message<"chalk.notebook.v1.NotebookOutputDataframe"> & {
  /**
   * @generated from field: chalk.notebook.v1.NotebookOutputDataframePreview preview = 1;
   */
  preview?: NotebookOutputDataframePreview;

  /**
   * Present iff this result was served from cache rather than executed.
   * Persisted with the output chunk, so the age indicator survives reloads.
   *
   * @generated from field: chalk.notebook.v1.NotebookSqlCacheInfo cache_info = 2;
   */
  cacheInfo?: NotebookSqlCacheInfo;

  /**
   * Per-column distributions over the WHOLE dataframe, not the preview: the
   * kernel computes these while the value is still in hand, since it is the
   * only layer that always holds every row. One entry per column, in schema
   * order. `percentiles` may be empty on an entry whose counts are populated —
   * see chalk.common.v1.ColumnProfile.
   *
   * @generated from field: repeated chalk.common.v1.ColumnProfile column_profiles = 3;
   */
  columnProfiles: ColumnProfile[];

  /**
   * @generated from oneof chalk.notebook.v1.NotebookOutputDataframe.backing
   */
  backing: {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputInlineDataframe inline = 10;
     */
    value: NotebookOutputInlineDataframe;
    case: "inline";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputDatasetRef dataset_output = 11;
     */
    value: NotebookOutputDatasetRef;
    case: "datasetOutput";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputSqlResultRef sql_result = 12;
     */
    value: NotebookOutputSqlResultRef;
    case: "sqlResult";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputPythonObjectRef python_object = 13;
     */
    value: NotebookOutputPythonObjectRef;
    case: "pythonObject";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputBlobRef blob = 14;
     */
    value: NotebookOutputBlobRef;
    case: "blob";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputDataframe.
 * Use `create(NotebookOutputDataframeSchema)` to create a new message.
 */
export const NotebookOutputDataframeSchema: GenMessage<NotebookOutputDataframe> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 9);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputText
 */
export type NotebookOutputText = Message<"chalk.notebook.v1.NotebookOutputText"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputText.
 * Use `create(NotebookOutputTextSchema)` to create a new message.
 */
export const NotebookOutputTextSchema: GenMessage<NotebookOutputText> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 10);

/**
 * A chart produced by a cell (e.g. a plotly figure the kernel translated into
 * Chalk's chart format), tracked as a first-class output kind like dataframes.
 * The payload is the protojson encoding of chalk.chart.v3.TabularChart with
 * its Arrow data inline (base64 per protojson bytes rules). protojson rather
 * than a typed field keeps intermediate services pass-through: the chart is
 * produced by the in-kernel Python translator and consumed by the frontend
 * renderer; the kernel, orchestrator, and persistence treat it as opaque.
 *
 * @generated from message chalk.notebook.v1.NotebookOutputChart
 */
export type NotebookOutputChart = Message<"chalk.notebook.v1.NotebookOutputChart"> & {
  /**
   * protojson-encoded chalk.chart.v3.TabularChart.
   *
   * @generated from field: string tabular_chart_json = 1;
   */
  tabularChartJson: string;

  /**
   * The producing translator, e.g. "plotly" or "altair".
   *
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * A raw Vega-Lite spec (JSON with inline data) passed through untranslated,
   * set instead of tabular_chart_json for sources whose native format IS a
   * declarative spec (altair). The frontend translates a supported subset
   * into a chalk chart and falls back to a vega renderer for the rest, so
   * the kernel and intermediate services stay pass-through here too.
   *
   * @generated from field: string vega_lite_json = 3;
   */
  vegaLiteJson: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputChart.
 * Use `create(NotebookOutputChartSchema)` to create a new message.
 */
export const NotebookOutputChartSchema: GenMessage<NotebookOutputChart> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 11);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputDisplay
 */
export type NotebookOutputDisplay = Message<"chalk.notebook.v1.NotebookOutputDisplay"> & {
  /**
   * @generated from field: string mime_type = 1;
   */
  mimeType: string;

  /**
   * @generated from field: string data = 2;
   */
  data: string;

  /**
   * @generated from field: string text = 3;
   */
  text: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputDisplay.
 * Use `create(NotebookOutputDisplaySchema)` to create a new message.
 */
export const NotebookOutputDisplaySchema: GenMessage<NotebookOutputDisplay> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 12);

/**
 * @generated from message chalk.notebook.v1.NotebookPythonStackFrameContextLine
 */
export type NotebookPythonStackFrameContextLine = Message<"chalk.notebook.v1.NotebookPythonStackFrameContextLine"> & {
  /**
   * @generated from field: int32 line = 1;
   */
  line: number;

  /**
   * @generated from field: string source_line = 2;
   */
  sourceLine: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookPythonStackFrameContextLine.
 * Use `create(NotebookPythonStackFrameContextLineSchema)` to create a new message.
 */
export const NotebookPythonStackFrameContextLineSchema: GenMessage<NotebookPythonStackFrameContextLine> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 13);

/**
 * @generated from message chalk.notebook.v1.NotebookPythonStackFrame
 */
export type NotebookPythonStackFrame = Message<"chalk.notebook.v1.NotebookPythonStackFrame"> & {
  /**
   * @generated from field: string file = 1;
   */
  file: string;

  /**
   * @generated from field: int32 line = 2;
   */
  line: number;

  /**
   * @generated from field: string function = 3;
   */
  function: string;

  /**
   * @generated from field: string source_line = 4;
   */
  sourceLine: string;

  /**
   * @generated from field: optional int32 column_start = 5;
   */
  columnStart?: number;

  /**
   * @generated from field: optional int32 column_end = 6;
   */
  columnEnd?: number;

  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookPythonStackFrameContextLine context_lines = 7;
   */
  contextLines: NotebookPythonStackFrameContextLine[];
};

/**
 * Describes the message chalk.notebook.v1.NotebookPythonStackFrame.
 * Use `create(NotebookPythonStackFrameSchema)` to create a new message.
 */
export const NotebookPythonStackFrameSchema: GenMessage<NotebookPythonStackFrame> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 14);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputError
 */
export type NotebookOutputError = Message<"chalk.notebook.v1.NotebookOutputError"> & {
  /**
   * @generated from field: string error_name = 1;
   */
  errorName: string;

  /**
   * @generated from field: string error_message = 2;
   */
  errorMessage: string;

  /**
   * @generated from field: string traceback = 3;
   */
  traceback: string;

  /**
   * @generated from field: string text = 4;
   */
  text: string;

  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookPythonStackFrame stack_frames = 5;
   */
  stackFrames: NotebookPythonStackFrame[];
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputError.
 * Use `create(NotebookOutputErrorSchema)` to create a new message.
 */
export const NotebookOutputErrorSchema: GenMessage<NotebookOutputError> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 15);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputStatus
 */
export type NotebookOutputStatus = Message<"chalk.notebook.v1.NotebookOutputStatus"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputStatus.
 * Use `create(NotebookOutputStatusSchema)` to create a new message.
 */
export const NotebookOutputStatusSchema: GenMessage<NotebookOutputStatus> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 16);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputVariable
 */
export type NotebookOutputVariable = Message<"chalk.notebook.v1.NotebookOutputVariable"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * Legacy loose string kind ("local"/"module"/"dataframe"). Retained for
   * back-compat; new consumers should read variable_kind.
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string type_label = 3;
   */
  typeLabel: string;

  /**
   * @generated from field: string value_label = 4;
   */
  valueLabel: string;

  /**
   * @generated from field: optional chalk.arrow.v1.ScalarValue scalar_value = 5;
   */
  scalarValue?: ScalarValue;

  /**
   * True when this variable was created or changed by the cell that produced
   * this snapshot. Every run reports the full user namespace (for the variable
   * explorer); the per-cell view filters to changed=true.
   *
   * @generated from field: bool changed = 6;
   */
  changed: boolean;

  /**
   * Structured classification of the value. Preferred over the legacy `kind`
   * string.
   *
   * @generated from field: chalk.notebook.v1.NotebookVariableKind variable_kind = 7;
   */
  variableKind: NotebookVariableKind;

  /**
   * Bounded preview (columns + first rows as Arrow IPC) captured only for
   * DATAFRAME-kind variables, so any dataframe in kernel scope can serve as a
   * dynamic values source for SELECT/MULTISELECT input cells. Unset when the
   * value has no cheap tabular preview (e.g. LazyFrame) or capture failed.
   *
   * @generated from field: chalk.notebook.v1.NotebookOutputDataframePreview dataframe_preview = 8;
   */
  dataframePreview?: NotebookOutputDataframePreview;
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputVariable.
 * Use `create(NotebookOutputVariableSchema)` to create a new message.
 */
export const NotebookOutputVariableSchema: GenMessage<NotebookOutputVariable> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 17);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputVariables
 */
export type NotebookOutputVariables = Message<"chalk.notebook.v1.NotebookOutputVariables"> & {
  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookOutputVariable variables = 1;
   */
  variables: NotebookOutputVariable[];
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputVariables.
 * Use `create(NotebookOutputVariablesSchema)` to create a new message.
 */
export const NotebookOutputVariablesSchema: GenMessage<NotebookOutputVariables> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 18);

/**
 * @generated from message chalk.notebook.v1.NotebookOutputChunk
 */
export type NotebookOutputChunk = Message<"chalk.notebook.v1.NotebookOutputChunk"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string run_id = 2;
   */
  runId: string;

  /**
   * @generated from field: string cell_run_id = 3;
   */
  cellRunId: string;

  /**
   * @generated from field: string cell_id = 4;
   */
  cellId: string;

  /**
   * Monotonic per-run sequence stamped by the orchestrating server (never by
   * the kernel). Total-orders all chunks within a run and is the resume
   * cursor for WatchNotebookRun.
   *
   * @generated from field: int64 sequence = 5;
   */
  sequence: bigint;

  /**
   * @generated from field: chalk.notebook.v1.NotebookOutputChunkKind kind = 6;
   */
  kind: NotebookOutputChunkKind;

  /**
   * @generated from field: string result_variable_name = 10;
   */
  resultVariableName: string;

  /**
   * @generated from field: int64 row_count = 11;
   */
  rowCount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * Set only on chunks produced by evaluating a template expression
   * (RunPythonCellSpec.template_expressions); carries that expression's key so
   * renderers can place the value (or error) at its `{{ }}` site. Empty for
   * ordinary cell output, including stdout printed *during* template
   * evaluation — side-effect output is deliberately not attributed to a site.
   *
   * @generated from field: string expression_key = 13;
   */
  expressionKey: string;

  /**
   * @generated from oneof chalk.notebook.v1.NotebookOutputChunk.payload
   */
  payload: {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputText text_output = 20;
     */
    value: NotebookOutputText;
    case: "textOutput";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputDisplay display = 21;
     */
    value: NotebookOutputDisplay;
    case: "display";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputError error = 22;
     */
    value: NotebookOutputError;
    case: "error";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputDataframe dataframe = 23;
     */
    value: NotebookOutputDataframe;
    case: "dataframe";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputStatus status_output = 24;
     */
    value: NotebookOutputStatus;
    case: "statusOutput";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputVariables variables = 25;
     */
    value: NotebookOutputVariables;
    case: "variables";
  } | {
    /**
     * @generated from field: chalk.notebook.v1.NotebookOutputChart chart = 26;
     */
    value: NotebookOutputChart;
    case: "chart";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.notebook.v1.NotebookOutputChunk.
 * Use `create(NotebookOutputChunkSchema)` to create a new message.
 */
export const NotebookOutputChunkSchema: GenMessage<NotebookOutputChunk> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 19);

/**
 * @generated from message chalk.notebook.v1.NotebookRunEvent
 */
export type NotebookRunEvent = Message<"chalk.notebook.v1.NotebookRunEvent"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string cell_run_id = 2;
   */
  cellRunId: string;

  /**
   * @generated from field: string cell_id = 3;
   */
  cellId: string;

  /**
   * Per-run sequence assigned by the orchestrating server. Lifecycle events
   * replayed by WatchNotebookRun are re-synthesized and must be treated
   * idempotently; only OUTPUT_CHUNK sequences are stable resume cursors.
   *
   * @generated from field: int64 sequence = 4;
   */
  sequence: bigint;

  /**
   * @generated from field: chalk.notebook.v1.NotebookRunEventType event_type = 5;
   */
  eventType: NotebookRunEventType;

  /**
   * @generated from field: chalk.notebook.v1.NotebookRunStatus status = 6;
   */
  status: NotebookRunStatus;

  /**
   * @generated from field: int64 execution_count = 14;
   */
  executionCount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp occurred_at = 18;
   */
  occurredAt?: Timestamp;

  /**
   * @generated from field: chalk.notebook.v1.NotebookOutputChunk output = 19;
   */
  output?: NotebookOutputChunk;
};

/**
 * Describes the message chalk.notebook.v1.NotebookRunEvent.
 * Use `create(NotebookRunEventSchema)` to create a new message.
 */
export const NotebookRunEventSchema: GenMessage<NotebookRunEvent> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 20);

/**
 * @generated from message chalk.notebook.v1.NotebookCellResult
 */
export type NotebookCellResult = Message<"chalk.notebook.v1.NotebookCellResult"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string cell_id = 2;
   */
  cellId: string;

  /**
   * @generated from field: string latest_cell_run_id = 3;
   */
  latestCellRunId: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookRunStatus status = 4;
   */
  status: NotebookRunStatus;

  /**
   * @generated from field: string result_variable_name = 5;
   */
  resultVariableName: string;

  /**
   * @generated from field: int64 row_count = 6;
   */
  rowCount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 7;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 8;
   */
  finishedAt?: Timestamp;

  /**
   * @generated from field: repeated chalk.notebook.v1.NotebookOutputChunk outputs = 9;
   */
  outputs: NotebookOutputChunk[];
};

/**
 * Describes the message chalk.notebook.v1.NotebookCellResult.
 * Use `create(NotebookCellResultSchema)` to create a new message.
 */
export const NotebookCellResultSchema: GenMessage<NotebookCellResult> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 21);

/**
 * Run-level history entry (one StartNotebookRun invocation).
 *
 * @generated from message chalk.notebook.v1.NotebookRunSummary
 */
export type NotebookRunSummary = Message<"chalk.notebook.v1.NotebookRunSummary"> & {
  /**
   * @generated from field: string run_id = 1;
   */
  runId: string;

  /**
   * @generated from field: string notebook_id = 2;
   */
  notebookId: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookRunStatus status = 3;
   */
  status: NotebookRunStatus;

  /**
   * @generated from field: string run_scope = 4;
   */
  runScope: string;

  /**
   * @generated from field: string created_by = 5;
   */
  createdBy: string;

  /**
   * Document revision the run executed against; resolvable via
   * GetNotebookDocument(revision_id).
   *
   * @generated from field: string notebook_version_id = 6;
   */
  notebookVersionId: string;

  /**
   * @generated from field: int32 cell_count = 7;
   */
  cellCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 9;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 10;
   */
  finishedAt?: Timestamp;
};

/**
 * Describes the message chalk.notebook.v1.NotebookRunSummary.
 * Use `create(NotebookRunSummarySchema)` to create a new message.
 */
export const NotebookRunSummarySchema: GenMessage<NotebookRunSummary> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 22);

/**
 * @generated from message chalk.notebook.v1.NotebookCellRunHistoryEntry
 */
export type NotebookCellRunHistoryEntry = Message<"chalk.notebook.v1.NotebookCellRunHistoryEntry"> & {
  /**
   * @generated from field: string notebook_id = 1;
   */
  notebookId: string;

  /**
   * @generated from field: string cell_id = 2;
   */
  cellId: string;

  /**
   * @generated from field: string cell_run_id = 3;
   */
  cellRunId: string;

  /**
   * @generated from field: string run_id = 4;
   */
  runId: string;

  /**
   * @generated from field: chalk.notebook.v1.NotebookRunStatus status = 5;
   */
  status: NotebookRunStatus;

  /**
   * @generated from field: string run_scope = 6;
   */
  runScope: string;

  /**
   * @generated from field: string result_variable_name = 7;
   */
  resultVariableName: string;

  /**
   * @generated from field: int64 output_count = 8;
   */
  outputCount: bigint;

  /**
   * @generated from field: int64 row_count = 9;
   */
  rowCount: bigint;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 10;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp finished_at = 11;
   */
  finishedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 12;
   */
  createdAt?: Timestamp;

  /**
   * Populated when the cell run failed or was canceled.
   *
   * @generated from field: string error_message = 13;
   */
  errorMessage: string;
};

/**
 * Describes the message chalk.notebook.v1.NotebookCellRunHistoryEntry.
 * Use `create(NotebookCellRunHistoryEntrySchema)` to create a new message.
 */
export const NotebookCellRunHistoryEntrySchema: GenMessage<NotebookCellRunHistoryEntry> = /*@__PURE__*/
  messageDesc(file_chalk_notebook_v1_runtime, 23);

/**
 * @generated from enum chalk.notebook.v1.NotebookRunStatus
 */
export enum NotebookRunStatus {
  /**
   * @generated from enum value: NOTEBOOK_RUN_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_RUN_STATUS_QUEUED = 1;
   */
  QUEUED = 1,

  /**
   * @generated from enum value: NOTEBOOK_RUN_STATUS_RUNNING = 2;
   */
  RUNNING = 2,

  /**
   * @generated from enum value: NOTEBOOK_RUN_STATUS_SUCCESS = 3;
   */
  SUCCESS = 3,

  /**
   * @generated from enum value: NOTEBOOK_RUN_STATUS_ERROR = 4;
   */
  ERROR = 4,

  /**
   * @generated from enum value: NOTEBOOK_RUN_STATUS_CANCELED = 5;
   */
  CANCELED = 5,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookRunStatus.
 */
export const NotebookRunStatusSchema: GenEnum<NotebookRunStatus> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_runtime, 0);

/**
 * @generated from enum chalk.notebook.v1.NotebookRunEventType
 */
export enum NotebookRunEventType {
  /**
   * @generated from enum value: NOTEBOOK_RUN_EVENT_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_RUN_EVENT_TYPE_RUN_STARTED = 1;
   */
  RUN_STARTED = 1,

  /**
   * @generated from enum value: NOTEBOOK_RUN_EVENT_TYPE_CELL_QUEUED = 2;
   */
  CELL_QUEUED = 2,

  /**
   * @generated from enum value: NOTEBOOK_RUN_EVENT_TYPE_CELL_STARTED = 3;
   */
  CELL_STARTED = 3,

  /**
   * @generated from enum value: NOTEBOOK_RUN_EVENT_TYPE_OUTPUT_CHUNK = 4;
   */
  OUTPUT_CHUNK = 4,

  /**
   * @generated from enum value: NOTEBOOK_RUN_EVENT_TYPE_CELL_FINISHED = 5;
   */
  CELL_FINISHED = 5,

  /**
   * @generated from enum value: NOTEBOOK_RUN_EVENT_TYPE_RUN_FINISHED = 6;
   */
  RUN_FINISHED = 6,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookRunEventType.
 */
export const NotebookRunEventTypeSchema: GenEnum<NotebookRunEventType> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_runtime, 1);

/**
 * @generated from enum chalk.notebook.v1.NotebookOutputChunkKind
 */
export enum NotebookOutputChunkKind {
  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_STDOUT = 1;
   */
  STDOUT = 1,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_STDERR = 2;
   */
  STDERR = 2,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_RESULT = 3;
   */
  RESULT = 3,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_DISPLAY = 4;
   */
  DISPLAY = 4,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_ERROR = 5;
   */
  ERROR = 5,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_DATAFRAME = 6;
   */
  DATAFRAME = 6,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_STATUS = 7;
   */
  STATUS = 7,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_VARIABLES = 8;
   */
  VARIABLES = 8,

  /**
   * @generated from enum value: NOTEBOOK_OUTPUT_CHUNK_KIND_CHART = 9;
   */
  CHART = 9,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookOutputChunkKind.
 */
export const NotebookOutputChunkKindSchema: GenEnum<NotebookOutputChunkKind> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_runtime, 2);

/**
 * Coarse classification of a Python value in the notebook namespace. Drives the
 * variable explorer's per-kind labels and pill colors. Kept intentionally small:
 * enough to distinguish the shapes users care about, not a full type system.
 *
 * @generated from enum chalk.notebook.v1.NotebookVariableKind
 */
export enum NotebookVariableKind {
  /**
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Primitive scalar (int/float/bool/str/None/bytes/datetime/decimal). These
   * also carry an Arrow scalar_value.
   *
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_SCALAR = 1;
   */
  SCALAR = 1,

  /**
   * list/tuple/set/frozenset and other non-mapping sequences.
   *
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_COLLECTION = 2;
   */
  COLLECTION = 2,

  /**
   * dict and other mappings.
   *
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_MAPPING = 3;
   */
  MAPPING = 3,

  /**
   * pandas/polars DataFrame (and Series treated as tabular).
   *
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_DATAFRAME = 4;
   */
  DATAFRAME = 4,

  /**
   * Imported module.
   *
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_MODULE = 5;
   */
  MODULE = 5,

  /**
   * Function, builtin, method, or other callable that is not a class.
   *
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_FUNCTION = 6;
   */
  FUNCTION = 6,

  /**
   * Class / type object.
   *
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_CLASS = 7;
   */
  CLASS = 7,

  /**
   * Fallback: any other object instance.
   *
   * @generated from enum value: NOTEBOOK_VARIABLE_KIND_OBJECT = 8;
   */
  OBJECT = 8,
}

/**
 * Describes the enum chalk.notebook.v1.NotebookVariableKind.
 */
export const NotebookVariableKindSchema: GenEnum<NotebookVariableKind> = /*@__PURE__*/
  enumDesc(file_chalk_notebook_v1_runtime, 3);

